import { createStore } from 'redux'
import RootReducer from './RootReducer'

// Store holds all global data in one place

const initialState = {
    api: {
        error: {
            message: '',
        },
    }
}

//3rd argument is for "enhancers" which overload dispatch, getState and subscribe
const Store = createStore(RootReducer, initialState)

export default Store